<script lang="ts" setup>
import { useI18n } from "vue-i18n";

import type { SimpleProduct } from "@/types";

defineProps<{
  username: string;
  product: SimpleProduct;
}>();

const { t } = useI18n();
</script>

<template>
  <div>
    <p class="le-order-details__username">{{ username }}</p>
    <table class="le-order-details__table">
      <thead class="sr-only">
        <tr>
          <th>{{ t("le-order-details.product-header") }}</th>
          <th>{{ t("le-order-details.price-header") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="le-order-details__element">{{ product.name }}</td>
          <td class="le-order-details__element le-order-details__element--right-aligned">
            {{
              t("le-order-details.monthly-formatted-price", {
                price: product.price,
                currency: product.currency
              })
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-order-details {
  &__username {
    margin-bottom: 8px;
    padding: 6px 0;
  }

  &__table {
    width: 100%;
    margin-bottom: 26px;
    border-top: 1px solid @colors[@secondary][600];
    border-bottom: 1px solid @colors[@secondary][600];
    .body-text("m", "semi-bold");
  }

  &__element {
    padding: 12px;

    &--right-aligned {
      text-align: right;
    }
  }
}
</style>
